var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKdswap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KDSWAP",
    transform: "translate(-135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64950",
    "data-name": "Path 64950",
    d: "M155.47,6.352V9.529H165V6.352h-6.352V0h-9.529V3.177h6.352Z",
    transform: "translate(11.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64951",
    "data-name": "Path 64951",
    d: "M162.883,9.176V7.059h-3.177v3.177h3.177Z",
    transform: "translate(19.765 5.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64952",
    "data-name": "Path 64952",
    d: "M165.706,10.588h-3.177v6.354h-6.352v3.175h9.529V13.765h6.352V10.588Z",
    transform: "translate(16.942 8.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64953",
    "data-name": "Path 64953",
    d: "M166.058,20.47h-6.352V30h3.177V23.647h6.352V14.118h-3.177Z",
    transform: "translate(19.765 11.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64954",
    "data-name": "Path 64954",
    d: "M148.765,0h-3.177V3.177h3.177Z",
    transform: "translate(8.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64955",
    "data-name": "Path 64955",
    d: "M145.236,8.952l.929.931,3.177,3.175h18.13v6.354h3.175V9.883H150.658l-3.175-3.177H157.94V3.529H142.059V19.412h3.177Z",
    transform: "translate(5.647 2.823)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64956",
    "data-name": "Path 64956",
    d: "M151.588,27.881V24.706h-9.529v3.175h6.352v6.354h9.529V31.058h-6.352Z",
    transform: "translate(5.647 19.765)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64957",
    "data-name": "Path 64957",
    d: "M138.529,22.236v2.117h3.177V21.176h-3.177Z",
    transform: "translate(2.823 16.941)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64958",
    "data-name": "Path 64958",
    d: "M150.883,14.118h-9.531V20.47H135v3.177h9.529V17.293h6.354Z",
    transform: "translate(0 11.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64959",
    "data-name": "Path 64959",
    d: "M138.177,16.588h6.352V7.059h-3.177v6.352H135V22.94h3.177Z",
    transform: "translate(0 5.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64960",
    "data-name": "Path 64960",
    d: "M155.824,28.235h-3.177v3.177h3.177Z",
    transform: "translate(14.118 22.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64961",
    "data-name": "Path 64961",
    d: "M167.471,28.107,163.364,24H145.236V17.647h-3.177v9.529h19.989l3.175,3.177H154.765V33.53h15.881V17.647h-3.175Z",
    transform: "translate(5.647 14.118)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKdswap);
export default __webpack_public_path__ + "static/media/kdswap.37851a8184cc16599d79a43701479414.svg";
export { ForwardRef as ReactComponent };